exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-action[data-v-00dfa5f8],.td-actions[data-v-00dfa5f8]{text-align:center}.btn-action[data-v-00dfa5f8]{width:80%}.detail[data-v-00dfa5f8],.detail p[data-v-00dfa5f8]{font-size:small;padding:4px;margin:0}.detail-title[data-v-00dfa5f8]{font-weight:bolder}.detail-row[data-v-00dfa5f8]:hover{background-color:#eee}.detail-image[data-v-00dfa5f8]{width:50px}.detail-divider[data-v-00dfa5f8]{padding:0}", ""]);

// exports
